import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="column-checkbox"
export default class extends Controller {
  static values = { selector: String }
  
  toggle(event) {
    event.preventDefault()
    const isChecked = event.currentTarget.checked
    const selector = this.selectorValue
    
    // Find all checkboxes with the matching class within the form
    const form = this.element.closest('form')
    if (form) {
      form.querySelectorAll(`input[type="checkbox"].${selector}`).forEach(checkbox => {
        checkbox.checked = isChecked
      })
    }
  }
}